import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const reviewerContract = c.router(
  {
    getAppointmentAudioFileSignedUrl: {
      method: 'GET',
      path: '/audio-file/:tenantId/:appointmentId',
      responses: {
        200: z.object({
          presignedUrl: z.string().nullable(),
        }),
      },
      summary:
        'Requests a presigned GCS Url for downloading a single transcoded audio file for the appointment',
    },
    getAppointmentFileSignedUrl: {
      method: 'GET',
      path: '/file/:tenantId/:appointmentId/:fileId',
      responses: {
        200: z.object({
          presignedUrl: z.string().nullable(),
        }),
      },
      summary:
        'Requests a presigned GCS Url for downloading an appointment file',
    },
    prepareUtterances: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/prepare-utterances',
      body: z.object({}),
      responses: {
        200: z.object({}),
      },
      summary:
        'Prepares utterances for the appointment by converting the raw metadata into structured data',
    },
    clearUtterances: {
      method: 'DELETE',
      path: '/:tenantId/:appointmentId/utterances',
      body: z.object({}),
      responses: {
        200: z.object({}),
      },
      summary:
        'Clears all utterances and utterance fragments for the appointment',
    },
    splitUtterance: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/:utteranceId/split',
      body: z.object({
        fragmentId: z.string(),
      }),
      responses: {
        201: z.object({
          newUtteranceId: z.string(),
        }),
        400: z.object({}),
      },
    },
    mergeUtterances: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/:utteranceId/merge',
      body: z.object({}),
      responses: {
        201: z.object({
          newUtteranceId: z.string(),
        }),
      },
      summary:
        'Merges the current utterance with the previous one based on the time',
    },
    resetUtterance: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/:utteranceId/reset',
      body: z.object({}),
      responses: {
        201: z.object({
          newUtteranceId: z.string(),
        }),
      },
      summary:
        'Resets the current utterance to its original text. Does not reset the speaker or the time',
    },
    exportDiff: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/export-diff',
      body: z.object({
        type: z.enum(['summary', 'ehr']),
      }),
      responses: {
        200: z.object({
          downloadUrl: z.string(),
        }),
        404: z.void(),
      },
      summary: 'Export appointment diff as CSV file (summary or EHR)',
    },
    scheduleGroundednessEval: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/schedule-groundedness-eval',
      body: z.object({
        llmOutputId: z.string().uuid(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
      summary: 'Schedules groundedness eval job for given llm output',
    },
  },
  { pathPrefix: '/review' },
);
